import {
  Routes,
  Route,
} from "react-router-dom";
import Dashboard from "./Dashboard"
import EfileSettings from "./EfileSettings";

export default function MainRoutes() {
  return (
    <Routes>
      <Route path="efile" element={<EfileSettings />} />
      <Route path="*" element={<Dashboard />} />
    </Routes>
  );
}